import React from "react";

const IconBookOpen = () => {
    return (
        <svg
            width="19"
            height="17"
            viewBox="0 0 19 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.22 15.3796C8.00831 14.5542 6.57614 14.1127 5.11 14.1127C3.64386 14.1127 2.21169 14.5542 1 15.3796V2.26962C2.21169 1.44417 3.64386 1.00269 5.11 1.00269C6.57614 1.00269 8.00831 1.44417 9.22 2.26962V15.3796Z"
                fill="white"
                stroke="#555E67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4287 15.3797C16.2191 14.5538 14.7885 14.112 13.3238 14.112C11.859 14.112 10.4284 14.5538 9.21875 15.3797V2.26968C10.4284 1.44377 11.859 1.00195 13.3238 1.00195C14.7885 1.00195 16.2191 1.44377 17.4287 2.26968V15.3797Z"
                fill="white"
                stroke="#555E67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconBookOpen;
